<template src='./index.html'></template>
<script>
import { dsrw_save, dsrw_update, dsrwxx_query } from '@/api/dsrw';

export default {
    name: 'addTask',
    props: {
        taskDialog: {
            type: Boolean,
            default: false
        },
        //用于判断是哪个界面  0:新增 1：编辑
        wikiType: {
            type: String,
            default: ''
        },
        dialogTitle: {
            type: String,
            default: ''
        },
        diaFormData: {
            type: Object,
            default: {}
        }
    },
    watch: {
        diaFormData: function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(function() {
                    this.formData = this.diaFormData
                })
            }
        }
    },
    data: function() {
        return {
            taskList: [],
            formData: {},
            taskData: []
        };
    },
    created() {

    },
    mounted() {
        this.init();
    },
    methods: {
        closediag() {
            this.$emit('closediag', false);
            this.formData = {};
        },
        saveTask() {
            let params = {};
            let task = this.taskData.filter(item => item.methodName === this.formData.invokeTarget);
            if (task.length > 0) {
                params = this.formData;
                params.jobName = task[0].taskName;
                params.jobGroup = task[0].jobGroup;
                params.invokeTarget = task[0].methodName;
                params.misfirePolicy = task[0].misfirePolicy;
                params.concurrent = task[0].concurrent;
                params.jobStatus = "0";
            }
            if (this.saveVerify(params)) {
                if (this.wikiType === "1") {
                    // 修改
                    dsrw_update(params).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success('保存成功！');
                            this.closediag();
                        } else {
                            this.$message.error(res.data.msg + ":" +res.data.data);
                        }
                    })
                } else if (this.wikiType === "0") {
                    // 新增
                    dsrw_save(params).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success('保存成功！');
                            this.closediag();
                        } else {
                            this.$message.error(res.data.msg + ":" +res.data.data);
                        }
                    })
                }
            }
        },
        saveVerify(params) {
            if (!params.jobName) {
                this.$message.error('请选择定时任务');
                return false;
            }
            if (!params.remark) {
                this.$message.error('请填写实例名称');
                return false;
            }
            if (!params.cronExpression) {
                this.$message.error('请填写定时参数');
                return false;
            }
            return true;
        },
        init() {
            dsrwxx_query().then(res => {
                if (res.data.code === "1") {
                    this.taskData = res.data.data
                    res.data.data.forEach((item, index) => {
                        this.taskList.push({
                            label:item.taskName,
                            value: item.methodName,
                        })
                    })
                }
            })
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
